import { css } from "styled-components";

export const VigaFont = css`
@import url('./fonts/Viga-Regular.ttf');
`;